import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Companies from '../views/Companies.vue'
import Company from '../views/Company.vue'
import Activity from '../views/Activity.vue'
import Audiences from '../views/Audiences.vue'
import Audience from '../views/Audience.vue'
import Activities from '../views/Activities.vue'
import Settings from '../views/Settings.vue'
import Signin from '../views/Signin.vue'
import Signout from '../views/Signout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/Companies',
    name: 'Companies',
    component: Companies
  },
  {
    path: '/Company/:Company_ID',
    name: 'Company',
    component: Company
  },

  {
    path: '/Activity/:Company_ID/Activity_id/:Activity_id',
    name: 'Activity',
    component: Activity
  },

  {
    path: '/Audiences',
    name: 'Audiences',
    component: Audiences
  },
  {
    path: '/Audience/:Email_id/Company/:Company_ID',
    name: 'Audience',
    component: Audience
  },
  {
    path: '/Activities',
    name: 'Activities',
    component: Activities
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/Signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/Signout',
    name: 'Signout',
    component: Signout
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
